import getListRequest from "./requests/get-list-request";
import diagnosticRequest from "./requests/diagnostic";

const v2CompanyRepository = {
    getList: getListRequest,
    diagnostic: diagnosticRequest,
};

export default v2CompanyRepository;